import apiVersion from '../_helpers/api-version';
import axiosInstance from '../_helpers/axiosConfig';

import { store } from '../_helpers/store';
import { axsToken } from '../_helpers/auth-header'

export const locationsService = {
  retrieve,
  addLocation,
  editLocation
};

function retrieve(page = 1) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/locations?providerId=${clientId}&page=${page}`,
  }).then(response => {
    return response.data;
  });
}

function addLocation(location = {}) {
  const providerId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/locations`,
    data: {
      providerId,
      ...location,
    }
  });
}
function editLocation(location = {}, locationId = "") {
  return axiosInstance.request({
    method: 'PATCH',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/locations/${locationId}`,
    data: location
  })
}